import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isProspect } from '@citrite/sf-api';
import URI from 'urijs';
import { getCachedToken, setCachedToken } from './tokenCache';
export function createRightSignatureClient(configuration) {
  var baseUrl = configuration.baseUrl.endsWith('/') ? configuration.baseUrl.slice(0, -1) : configuration.baseUrl;
  return {
    getDocuments: function getDocuments(params) {
      return request('GET', '/documents', {
        queryParams: params
      });
    },
    getReusableTemplates: function getReusableTemplates(params) {
      return request('GET', '/reusable_templates', {
        queryParams: params
      });
    },
    getReusableTemplate: function getReusableTemplate(templateId) {
      return request('GET', "/reusable_templates/".concat(templateId));
    },
    getFilledPreviewDocumentForReusableTemplate: function getFilledPreviewDocumentForReusableTemplate(templateId, prospect) {
      var requestBody = {
        merge_field_data: {
          Prospect: {
            'sharefile.prospect': _objectSpread({}, prospect)
          }
        }
      };
      return request('POST', "/reusable_templates/".concat(templateId, "/generate_preview"), {
        requestBody: requestBody
      }, false);
    },
    getFilledDocumentPreviewId: function getFilledDocumentPreviewId(templateId, contact) {
      var requestBody = {
        merge_field_data: _defineProperty({}, isProspect(contact) ? 'Prospect' : 'Client', _defineProperty({}, "sharefile.".concat(isProspect(contact) ? 'prospect' : 'client'), _objectSpread({}, contact)))
      };
      return request('POST', "/reusable_templates/".concat(templateId, "/previews"), {
        requestBody: requestBody
      }, false);
    },
    getFilledDocumentPreviewUrl: function getFilledDocumentPreviewUrl(documentPreviewId) {
      return request('GET', "/previews/".concat(documentPreviewId), {
        requestBody: undefined
      }, false);
    }
  };
  function request(_x, _x2, _x3) {
    return _request.apply(this, arguments);
  }
  function _request() {
    _request = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(method, path, data) {
      var isRetry,
        headers,
        url,
        requestConfig,
        response,
        _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            isRetry = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
            headers = new Headers({
              'x-bff-csrf': 'true'
            });
            if (!!configuration.useBff) {
              _context.next = 10;
              break;
            }
            _context.t0 = Headers;
            _context.next = 6;
            return getToken({
              useCache: true
            });
          case 6:
            _context.t1 = _context.sent;
            _context.t2 = 'Bearer ' + _context.t1;
            _context.t3 = {
              authorization: _context.t2
            };
            headers = new _context.t0(_context.t3);
          case 10:
            url = new URI("".concat(baseUrl).concat(path));
            requestConfig = {
              method: method,
              headers: headers
            };
            if (!!(data !== null && data !== void 0 && data.queryParams)) {
              url.query(data.queryParams);
            }
            if (!!(data !== null && data !== void 0 && data.requestBody)) {
              requestConfig.body = JSON.stringify(data.requestBody);
              headers.append('content-type', 'application/json; charset=utf-8');
            }
            _context.next = 16;
            return fetch(url.toString(), requestConfig);
          case 16:
            response = _context.sent;
            if (response.ok) {
              _context.next = 25;
              break;
            }
            if (!(!!!configuration.useBff && response.status === 401 && !isRetry)) {
              _context.next = 24;
              break;
            }
            _context.next = 21;
            return getToken({
              useCache: false
            });
          case 21:
            return _context.abrupt("return", request(method, path, data, true));
          case 24:
            throw response;
          case 25:
            return _context.abrupt("return", response.json());
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _request.apply(this, arguments);
  }
  function getToken(_x4) {
    return _getToken.apply(this, arguments);
  }
  function _getToken() {
    _getToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
      var useCache, cachedToken, freshToken;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            useCache = _ref2.useCache;
            if (!useCache) {
              _context2.next = 5;
              break;
            }
            cachedToken = getCachedToken();
            if (!cachedToken) {
              _context2.next = 5;
              break;
            }
            return _context2.abrupt("return", cachedToken);
          case 5:
            _context2.next = 7;
            return configuration.acquireAccessToken();
          case 7:
            freshToken = _context2.sent;
            setCachedToken(freshToken);
            return _context2.abrupt("return", freshToken);
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _getToken.apply(this, arguments);
  }
}